import { createQueryKeys } from '@lukemorales/query-key-factory';
import { PayMethodExhibitsFindResponse, payMethodExhibitApi } from '../../../lib/api/payMethodExhibit';
import {
  PaymentSettingLogsFindResponse,
  PaymentSettingLogsParams,
  PgProviderRoutesFindResponse,
  pgProviderRouteApi,
} from '../../../lib/api/pgProviderRoute';

export const pgProviderRouteQuery = createQueryKeys('pgProviderRoute', {
  list: () => ({
    queryKey: ['list'],
    queryFn: (): Promise<PgProviderRoutesFindResponse> => pgProviderRouteApi.getRoutes(),
  }),
  logs: (params: PaymentSettingLogsParams) => ({
    queryKey: [params],
    queryFn: (): Promise<PaymentSettingLogsFindResponse> => pgProviderRouteApi.getLogs(params),
  }),
});

export const payMethodExhibitQuery = createQueryKeys('payMethodExhibit', {
  list: () => ({
    queryKey: ['list'],
    queryFn: (): Promise<PayMethodExhibitsFindResponse> => payMethodExhibitApi.getPayMethods(),
  }),
});
